import React, { useContext } from 'react';
import proyectoContext from '../../context/proyectos/proyectoContext';
import criticaContext from '../../context/criticas/criticaContext';



const Proyecto = ({proyecto}) => {
    // Obtener el state de proyectos
    const proyectosContext = useContext(proyectoContext);
    const { proyectoActual } = proyectosContext;

    // obtener la función del context de critica
    const criticasContext = useContext(criticaContext);
    const { obtenerCriticas } = criticasContext;

    // Función para agregar el proyecto actual
    const seleccionarProyecto = id => {
        proyectoActual(id); // Fijar un proyecto actual
        obtenerCriticas(id); // Filtrar las criticas cuando se de click
    }

    return ( 
        <li>
            <button
                type="button"
                className="btn btn-sidebar"
                onClick={ () => seleccionarProyecto(proyecto._id) }
            >{proyecto.nombre} </button>
        </li>
     );
}
 
export default Proyecto;